<label *ngIf="label != null && label != '' && showLabel" class="sumax-label mb-0 p-0">{{label}}<span *ngIf="required"
    [class.text-danger]="controls?.errors != null"> *</span></label>

<div [class.input-icon]="controls?.errors != null && (controls?.dirty || controls?.touched) && submitted"
  [class.right]="controls?.errors != null && (controls?.dirty || controls?.touched) && submitted"
  [class.refresh]="controls?.errors != null && (controls?.dirty || controls?.touched) && submitted && refresh"
  [class.search]="controls?.errors != null && (controls?.dirty || controls?.touched) && submitted && search">
  <!-- tooltip-message es el icono de error -->
  <tooltip-message [label]="label" [controls]="controls" [validatorMessage]="validatorMessage" [submitted]="submitted"
    [tooltipMessage]="tooltipMessage"></tooltip-message>
  <div class="d-flex">
    <div class="w-100">
      <ng-select #ngSelectSimple [items]="items | async" [(ngModel)]="_value" [disabled]="disabled"
        [readonly]="readonly" (change)="eventChange($event)" (blur)="eventBlur($event)" (focus)="eventFocus($event)"
        [markFirst]="markFirst" [clearable]="!required && clearable" [virtualScroll]="virtualScroll"
        [inputAttrs]="{'autocomplete': autocomplete}" [clearOnBackspace]="clearOnBackspace" [openOnEnter]="openOnEnter"
        (keydown.delete)="(!required && clearable) ? clear(): ''" (clear)="clear()" (keyup.F1)="f1KeyUp()"
        notFoundText="No se encontraron resultados" placeholder="Seleccionar" (keyup.enter)="enterKeyUp()"
        [clearAllText]="clearAllText" [searchable]="searchable" (keyup.ArrowLeft)="leftKeyUp()" [appendTo]="appendTo"
        [loading]="loading" [loadingText]="loadingText"
        [class.ng-select-invalid]="controls?.errors != null && (controls?.dirty || controls?.touched) && submitted"
        [class.ng-select-touched]="controls?.errors != null && (controls?.dirty || controls?.touched) && submitted"
        [class.upperCase]="upperCase" [ngClass]="setNgClass">
        <!-- OPCIONES DE LISTADO -->
        <ng-template ng-option-tmp let-item="item" let-index="index">
          <span data-toggle="tooltip" title="{{item.label}}">{{ item.label }}</span>
        </ng-template>
      </ng-select>
    </div>

    <div class="bd-highlight" *ngIf="search">
      <button #btnSearch type="button" [disabled]="disabled || readonly" class="btn btn-success p-0 rounded-0 h-100"
        (keyup.ArrowLeft)="ngSelectSimple.focus()" (click)="onSearch()">
        <!-- <mat-icon class="text-white pt-1" style="font-size: 18px;" [matTooltip]="'Buscar'" matTooltipClass="bg-success">search</mat-icon> -->
        <i class="fa fa-search text-white px-1" [matTooltip]="'Buscar'" matTooltipClass="bg-success"></i>
      </button>
    </div>

    <div class="bd-highlight" *ngIf="refresh">
      <button *ngIf="refresh" type="button" [disabled]="disabled || readonly" class="btn btn-info p-0 rounded-0 h-100"
        (click)="onRefresh()">
        <!-- <mat-icon class="text-white pt-1" style="font-size: 18px;" [matTooltip]="'Refrescar'" matTooltipClass="bg-info">refresh</mat-icon> -->
        <i class="la la-refresh text-white px-1" [matTooltip]="'Refrescar'" matTooltipClass="bg-info"></i>
      </button>
    </div>
  </div>
</div>

<!-- error-message es el mansaje que aparece abajo del componente -->
<error-message [label]="label" [controls]="controls" [validatorMessage]="validatorMessage" [submitted]="submitted"
  [tooltipMessage]="tooltipMessage"></error-message>